import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  IconButton,
  Flex,
  Text,
  Button,
} from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

const VilTemplateSelectionView = ({
  isOpen,
  onClose,
  vilTemplates,
  onSelect,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === vilTemplates.length - 1 ? 0 : prev + 1
    );
  };

  const handlePrevious = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? vilTemplates.length - 1 : prev - 1
    );
  };

  const handleSelect = () => {
    onSelect(vilTemplates[currentIndex]);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
      <ModalOverlay />
      <ModalContent h={["90vh", "95vh"]}>
        <ModalHeader bg="green.500" color="white" borderTopRadius="md">
          Select VIL Template
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody maxH={["75vh", "80vh"]} overflowY="auto" p={4}>
          <Flex direction="column" align="center" h="100%">
            <Flex
              w="100%"
              align="center"
              justify="center"
              position="relative"
              flex="1"
            >
              <IconButton
                icon={<ChevronLeftIcon />}
                onClick={handlePrevious}
                position="absolute"
                left={0}
                top="50%"
                transform="translateY(-50%)"
                zIndex={2}
                colorScheme="blue"
                rounded="full"
                aria-label="Previous template"
              />

              <Box
                w="100%"
                h="100%"
                mx={12}
                position="relative"
                overflow="hidden"
              >
                <iframe
                  src={vilTemplates[currentIndex]?.template_image}
                  title={vilTemplates[currentIndex]?.template_name}
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                />
              </Box>

              <IconButton
                icon={<ChevronRightIcon />}
                onClick={handleNext}
                position="absolute"
                right={0}
                top="50%"
                transform="translateY(-50%)"
                zIndex={2}
                colorScheme="blue"
                rounded="full"
                aria-label="Next template"
              />
            </Flex>

            <Box mt={4} textAlign="center">
              <Text fontSize="lg" fontWeight="bold" mb={2}>
                {vilTemplates[currentIndex]?.template_name}
              </Text>
              <Text color="gray.500">
                Template {currentIndex + 1} of {vilTemplates.length}
              </Text>
            </Box>

            <Button
              mt={4}
              colorScheme="blue"
              onClick={handleSelect}
              size="lg"
              w="200px"
            >
              Select Template
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default VilTemplateSelectionView;
